import { useEffect, useRef } from "react";
import { useFetchApi } from "./useFetchApi";

export const useAnalysisStocks = (stockId?: number, summary?: string) => {
  const request = useFetchApi("/api/all-stocks", {}, "GET");
  const latest = useRef(request);
  latest.current = request;
  const isWaitingForSummary = Boolean(stockId) && !summary;

  useEffect(() => {
    if (!latest.current.loading) latest.current.execute();
  }, []);

  useEffect(() => {
    // Only a pending summary needs fresh data; once it's saved, refetching on
    // every tab switch just reloads the page for nothing.
    if (!isWaitingForSummary) return;

    const refresh = () => {
      if (!document.hidden && !latest.current.loading) {
        latest.current.execute();
      }
    };

    // Generation can outlast the approval request; keep waiting while visible.
    const timer = window.setInterval(refresh, 10000);
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, [isWaitingForSummary]);

  // Report loading only for the first fetch. Pages swap their content for
  // skeletons while loading, so background refreshes would remount every tab.
  return { ...request, loading: request.loading && !request.response };
};
